import { render, staticRenderFns } from "./myTalentDirectory.vue?vue&type=template&id=25d38200"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d38200')) {
      api.createRecord('25d38200', component.options)
    } else {
      api.reload('25d38200', component.options)
    }
    module.hot.accept("./myTalentDirectory.vue?vue&type=template&id=25d38200", function () {
      api.rerender('25d38200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/myTalentDirectory.vue"
export default component.exports